import axios from 'axios'

export default {
    namespaced: true,
    state: {
        list: [],
        data: {
            paymentId: 0,
        },
        counter: 0,
        load: false,
    },
    actions: {
        get: function (context, val) {
            if (!val) return;
            let url = '';
            context.state.data.paymentId = val;
            switch (context.rootState.finances.pay.system.type) {
                case 'regular':
                    url = '/tourclient/payment/attachmentsForRegularPayment?paymentId=' + context.state.data.paymentId + '&_=' + new Date().getTime();
                    break;
                case 'invoice':
                    url = '/tourclient/payment/attachmentsForInvoice?paymentId=' + context.state.data.paymentId + '&_=' + new Date().getTime();
                    break;
                case 'pay':
                    url = '/tourclient/payment/attachments?paymentId=' + context.state.data.paymentId + '&_=' + new Date().getTime();
                    break;
            }
            context.state.load = true;
            axios({
                url,
                method: 'get'
            }).then(r => {
                r.data.Files.forEach(item => {
                    item.name = item.Name;
                    item.url = window.location.origin + item.Url;
                });
                context.state.list = r.data.Files;
                context.state.load = false;
            }).catch(e => {
                context.dispatch('error', e, {root: true});
            });
        },
        remove: function (context, file) {
            if (context.state.data.paymentId) {
                let id;
                if (file.Id) {
                    id = file.Id
                }
                if (file.response && file.response.FileDescription && file.response.FileDescription.Id) {
                    id = file.response.FileDescription.Id
                }
                axios({
                    method: 'POST',
                    url: '/tourclient/Payment/RemoveFile',
                    data: ('id=' + id),
                });
            }
        },
        prev: function (context, val) {
            switch (context.rootState.finances.pay.system.action) {
                case 'edit':
                    if (val.response && val.response.FileDescription && val.response.FileDescription.Url) window.open(val.response.FileDescription.Url);
                    else window.open(val.url);
                    break;
            }
        },
        reload: function (context, val) {
            context.state = {
                list: [],
                data: {
                    paymentId: 0,
                },
                counter: 0,
                load: false,
            };
        },
        change: function (context, file) {
            if (!context.state.data.paymentId) {
                context.state.list.push({name: file.name, url: file.name, file: file});
                return false;
            }
        },
        save: function (context, id = context.state.files.data.paymentId) {
            let url = '';

            switch (context.rootState.finances.pay.system.type) {
                case 'pay':
                    url = '/tourclient/payment/attachFile';
                    break;
                case 'regular':
                    url = '/tourclient/payment/attachRegularPaymentFile';
                    break;
                case 'invoice':
                    url = '/tourclient/payment/attachInvoiceFile';
                    break;
            }
            if (!context.state.list.length) {
                context.dispatch('finances/pay/get_local', null, {root: true});
                return;
            }
            context.state.list.forEach(item => {
                let body = new FormData();
                body.append('paymentId', id);
                body.append('file', item.file.raw);
                let xhr = new XMLHttpRequest();
                xhr.open('POST', url, true);

                xhr.onreadystatechange = function () {
                    if (this.readyState !== 4) return;
                    if (this.status !== 200) {
                        context.state.counter++;
                    }
                    else {
                        context.state.counter++;
                        if (context.state.counter === context.state.list.length) {
                            context.dispatch('finances/pay/get_local', null, {root: true});
                        }
                    }
                };
                xhr.send(body);
            });
        },

    },
    getters: {
        action: function (state, getters, rootState) {
            switch (rootState.finances.pay.system.type) {
                case 'pay':
                    return '/tourclient/Payment/AttachFile';
                case 'regular':
                    return '/tourclient/Payment/AttachRegularPaymentFile';
                case 'invoice':
                    return '/tourclient/Payment/AttachInvoiceFile';
                default:
                    return '';
            }
        }
    },
    mutations: {},
}
